
	function ExampleForm(settings){
		this.className = "ExampleForm";

		this.name = "example";

		if(!settings) settings = {};

		settings = {
			template: ("template" in settings) ? settings.template : "form",
		};

		this.data = {
			pages: [
				{
					title: "",
					name: settings.template,
					errors: {
						general: "There are errors in your submission, please correct before continuing."
					},
					submissionUrl: "/forms/example",
				},
				{
					title: "Thanks",
					name: "complete"
				},
			]
		}

		this.setup(settings);
	};
	ExampleForm.inheritsFrom( PageForm );

